const cityService = require('../../services/city/cityService')
import { errorMessages } from '@/util/helpers'

const state = {
  cities: [],
  city: {},
  realEstateCity: {},
  isRealEstateCitiesLoading: false,
  isCitiesLoading: false,
}

const mutations = {
  setCities(state, cities) {
    state.cities = cities
  },
  setCity(state, city) {
    state.city = city
  },
  setRealEstateCity(state, city) {
    state.realEstateCity = city
  },
  setIsRealEstateCitiesLoading(state, status) {
    state.isRealEstateCitiesLoading = status
  },
  setIsCitiesLoading(state, status) {
    state.isCitiesLoading = status
  },
}

const actions = {
  async fetchCity({ commit, dispatch }, id) {
    commit('setIsLoading', true)

    await cityService
      .find(id)
      .then(({ data }) => {
        commit('setCity', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async fetchRealEstateCity({ commit }) {
    commit('setIsRealEstateCitiesLoading', true)

    await cityService
      .fetchRealEstateCity()
      .then(({ data }) => {
        commit('setRealEstateCity', data)
      })
      .finally(() => {
        commit('setIsRealEstateCitiesLoading', false)
      })
  },

  async updateCityStatus(state, id) {
    return cityService.updateStatus(id)
  },

  async updateCityServiceTypes(state, body) {
    return cityService.updateServices(body)
  },

  async fetchCitiesPaginated({ rootState, dispatch, commit }, search) {
    commit('setIsCitiesLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters, search }

    cityService
      .fetchCitiesPaginated(params)
      .then(({ data }) => {
        const { result, total } = data

        commit('setCities', result)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsCitiesLoading', false)
      })
  },

  async searchCity({ commit, dispatch }, city) {
    commit('setIsCitiesLoading', true)

    try {
      const { data } = await cityService.fetchCitiesPaginated({ search: city, size: 100 })
      commit('setCities', data?.result)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCitiesLoading', false)
    }
  },

  async fetchEnabledCitiesAdmin({ commit }) {
    const { data } = await cityService.fetchEnabledCitiesAdmin()
    commit('setCities', data)
  },

  async fetchCities({ commit, dispatch }) {
    try {
      const params = {
        countryCode: localStorage.getItem('user_country')
      }
      const { data } = await cityService.fetchCities(params)
      commit('setCities', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  async fetchCitiesAsAdmin({ commit, dispatch, rootState }) {
    try {
      const { data } = await cityService.fetchCitiesAsAdmin()
      commit('setCities', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  async fetchCitiesByRealties({ commit, dispatch }) {
    try {
      const { data } = await cityService.fetchCitiesByRealties()
      commit('setCities', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },
}

const getters = {
  cities: (state) => state.cities,
  city: (state) => state.city,
  realEstateCity: (state) => state.realEstateCity,
  isRealEstateCitiesLoading: (state) => state.isRealEstateCitiesLoading,
  isCitiesLoading: (state) => state.isCitiesLoading,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
